ORG_MASK = {
	# "Robots": "Hardware & Manufacturing",
	# "Brand": "Marketing and Communications",
	# "Executives": "Executive",
	# "Public Trust": "Legal",
	# "Design": "Industrial and Product Design"
	# "Operations & Commercialization": "Product Engineering",
}

DEPARTMENT_MASK = {
	# "Products & Programs, Autonomy": "Autonomy Products and Programs",
	# "G - Guardian (Teleoperations)": "Guardian (Teleoperations)",
	# "Robots Executives": "Hardware and Manufacturing Executives",
	# "NPI Hardware": "New Product Introduction (Hardware)",
	# "S&S Executives": "Safety and Systems Executives",
	# "Central Planning & Support": "Central Operations Planning & Support",
	# "Product Operations, Commercialization": "Product Operations (Commercialization)",
	# "Public Trust Executives": "Legal Executives",
	# "Workplace & Real Estate": "Workplace & Real Estate",
	# "HR": "Human Resources",
	# "DIBs": "Diversity, Inclusion, & Belonging",
	# "Operations & Commercialization": "Product Engineering",
}

JOB_LOCATION_MASK = {
	'Nuro HQ - Mountain View, CA': 'Mountain View, CA',
	'Mountain View, California, United States': 'Mountain View, CA',
	'California - HQ': 'Mountain View, CA',
	'California - SF': 'San Francisco, CA',
	'California - MV Depot': 'Mountain View, CA',
	'California - LA': 'Los Angeles, CA',
	'Arizona - Tempe': 'Tempe, AZ',
	'Tempe, Arizona, United States': 'Tempe, AZ',
	'Arizona - PHX': 'Phoenix, AZ',
	'Phoenix, Arizona, United States': 'Phoenix, AZ',
	'Texas - Depot 1': 'Houston, TX',
	'Texas - Depot 2': 'Houston, TX',
	'Houston, Texas, United States': 'Houston, TX',
	'Toronto': 'Toronto, Ontario, Canada',
	'Nevada - Las Vegas': 'Las Vegas, NV',
	'Las Vegas, Nevada, United States': 'Las Vegas, NV',
	'Remote - Idaho': 'Remote',
	'Remote - California': 'Remote',
	'Remote - Massachusetts': 'Remote',
	'Remote - Michigan': 'Remote',
	'Remote - New York': 'Remote',
	'Remote - North Carolina': 'Remote',
	'Remote - Ohio': 'Remote',
	'Remote - Oregon': 'Remote',
	'Remote - Pennsylvania': 'Remote',
	'Remote - Virginia': 'Remote',
	'Remote - Washington': 'Remote',
	'Remote - Washington D.C.': 'Remote',
	'Remote - Washington D.C': 'Remote',
	'Remote - Texas': 'Remote',
	'Remote - Illinois': 'Remote',
	'Remote - Alabama': 'Remote'
	'Shenzhen': 'Shenzhen, China',
}

JOB_TYPE_MASK = {
	'Regular': 'Full-Time'
}

import {BiderectionalMask} from '/services/helpers'
export OrgMap = new BiderectionalMask ORG_MASK
export JobTypeMap = new BiderectionalMask JOB_TYPE_MASK
export DepartmentMap = new BiderectionalMask DEPARTMENT_MASK
export JobLocationMap = new BiderectionalMask JOB_LOCATION_MASK

export default {}
